export const ExperimentsConsts = {
  AlwaysShowComplexPhoneField: 'specs.bookings.AlwaysShowComplexPhoneField',
  HideCouponInFormPage: 'specs.bookings.HideCouponInFormPage',
  ChangePricingPlanNavigationToNewApi:
    'specs.bookings.ChangePricingPlanNavigationToNewApi',
  BookingsFormWidgetCssOptimization:
    'specs.bookings.BookingsFormWidgetCssOptimization',
  EditorOOIFormPage: 'specs.bookings.EditorOOIFormPage',
  MultiServiceAppointment: 'specs.bookings.multiServiceAppointment',
  FormPaymentOptionNewDropdown: 'specs.bookings.FormPaymentOptionNewDropdown',
  AllowEditPolicySectionTitle: 'specs.bookings.AllowEditPolicySectionTitle',
  BookOnBehalf: 'specs.bookings.BookOnBehalf',
  ShouldShowCountryCodeWithFlags:
    'specs.bookings.ShouldShowCountryCodeWithFlags',
  ShowDurationInDays: 'specs.bookings.ShowDurationInDays',
  CancellationFeesUoU: 'specs.bookings.CancellationFeesUoU',
};
